import Input from "components/materials/Form/InputElement";
import classes from "./classes.module.scss";
import I18n from "components/materials/I18n";
import ThemeSelector from "components/materials/ThemeSelector";
import { EProjectTheme } from "common/enums/ProjectTheme/ProjectTheme";
import Select from "components/materials/Form/SelectElement";
import { EProjectFormat } from "common/enums/ProjectFormat/ProjectFormat";
import { TextArea } from "components/materials/Form/TextAreaElement";

type IProps = {
	selectedTheme: EProjectTheme | null;
	onSelect: (theme: EProjectTheme) => void;
};

export default function ProjectInfoInputs(props: IProps) {
	return (
		<div className={classes["root"]}>
			<Input
				name="title"
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_title}
				placeholder={I18n.asset.pages.professional_space.tabs.information.project_info.project_title_placeholder}
				required
			/>
			<TextArea
				name="pitch"
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch}
				placeholder={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch_placeholder}
				additionalInfo={I18n.asset.pages.professional_space.tabs.information.project_info.project_pitch_additional_info}
				required
			/>
			<ThemeSelector onSelect={props.onSelect} selectedTheme={props.selectedTheme} />
			<Select
				className={classes["select"]}
				name="format"
				label={I18n.asset.pages.professional_space.tabs.information.project_info.project_format}
				options={[
					{ label: I18n.asset.enums.EProjectFormats.long_metrage, value: EProjectFormat.long_metrage },
					{ label: I18n.asset.enums.EProjectFormats.court_metrage, value: EProjectFormat.court_metrage },
					{ label: I18n.asset.enums.EProjectFormats.serie, value: EProjectFormat.serie },
					{ label: I18n.asset.enums.EProjectFormats.documentaire, value: EProjectFormat.documentaire },
				]}
				required
			/>
		</div>
	);
}
